import dayjs from "dayjs";

/** Shared sync bond-list filters (law-firm bonds + archives baseline). */
export function applyCommonBondListFilters(rows, f, { includeUnderwriting = false } = {}) {
  let filtered = Array.isArray(rows) ? [...rows] : [];

  if (f.bondNumber?.length) {
    filtered = filtered.filter((b) =>
      f.bondNumber.some((x) => x.value === b.bond_number)
    );
  }
  if (f.startDate) {
    const start = dayjs(f.startDate).startOf("day");
    filtered = filtered.filter((b) =>
      dayjs(b.created_at).isSameOrAfter(start, "day")
    );
  }
  if (f.endDate) {
    const end = dayjs(f.endDate).endOf("day");
    filtered = filtered.filter((b) =>
      dayjs(b.created_at).isSameOrBefore(end, "day")
    );
  }
  if (f.bondType?.length) {
    filtered = filtered.filter((b) =>
      f.bondType.some((x) => x.value === b.bond_type)
    );
  }
  if (f.bondSubCategory?.length) {
    filtered = filtered.filter((b) =>
      f.bondSubCategory.includes(b.bond_sub_category)
    );
  }
  if (f.estate?.length) {
    filtered = filtered.filter((b) =>
      f.estate.some((x) => b.estate_name === x.label)
    );
  }
  if (f.lawFirm?.length) {
    filtered = filtered.filter((b) =>
      f.lawFirm.some((x) => b.law_firm_name === x.label)
    );
  }
  if (f.attorney?.length) {
    filtered = filtered.filter((b) =>
      f.attorney.some((x) => b.attorney_name === x.label)
    );
  }
  if (f.status?.length) {
    filtered = filtered.filter((b) => f.status.includes(b.status));
  }
  if (includeUnderwriting && f.underwriting_status?.length) {
    const selected = new Set(
      f.underwriting_status.map((s) => (s || "").toString().toLowerCase())
    );
    filtered = filtered.filter((b) =>
      selected.has((b.underwriting_status || "").toString().toLowerCase())
    );
  }

  return filtered;
}
